import { PlaceOrderSuccess } from "./PlaceOrderSuccess";

export default PlaceOrderSuccess;
